// extracted by mini-css-extract-plugin
module.exports = {"body":"cardbody_body__3a941"};